// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
import type {
  TDesktopMarkAsReadRequest,
  TDesktopMarkAsReadModel,
  IMappers,
  TDesktopMarkAsReadResponse,
  TDesktopMarkAsReadResponseData200,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IErrorResponseSchema } from '../../../entities/schemas/ErrorResponseSchema';

export function createDesktopMarkAsReadModel(parameters: TDesktopMarkAsReadRequest): TDesktopMarkAsReadModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'notification-center',
    pathApi: '/v1/desktop/mark-as-read/',
    response: {
      200: {},
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IDesktopMarkAsReadOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TDesktopMarkAsReadRequest;
}

export async function fetchDesktopMarkAsRead<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IDesktopMarkAsReadOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TDesktopMarkAsReadResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createDesktopMarkAsReadModel(parameters),
    config,
  )) as FetchResponse<TDesktopMarkAsReadResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TDesktopMarkAsReadResponseData200, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TDesktopMarkAsReadResponse>;
}
